import * as cfpmServices from '../services';

export default {
  namespace: 'cfpm',

  state: {
    fieldList: [],
    searchValue: {},
  },

  effects: {
    //设置查询的参数
    *setSearchValue({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          searchValue: { ...values },
        },
      });
    },
    //查询字段集合
    *getFieldPackageList({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(
        cfpmServices.getFieldPackageList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          fieldList: response || [],
        },
      });
    },
    //新增/编辑 字段集合
    *addFieldPackage({ payload: values, callback }, { call }) {
      const response = yield call(cfpmServices.addFieldPackage, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //删除 字段集合
    *deleteFieldPackage({ payload: { id }, callback }, { call }) {
      const { data: response } = yield call(
        cfpmServices.deleteFieldPackage,
        id,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //系统字段导出
    *exportFieldPackage({ payload: { id }, callback }, { call }) {
      const { data: response } = yield call(
        cfpmServices.exportFieldPackage,
        id,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 上传
    *uploadFile({ payload: { values }, callback }, { call }) {
      const { data: response } = yield call(cfpmServices.uploadFile, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
